function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 2.1161c-.8181.3589-1.6899.5968-2.5987.7123.935-.5583 1.6486-1.4355 1.984-2.4929-.8717.5197-1.8342.8869-2.86 1.0917C17.6977.546 16.518 0 15.231 0c-2.497 0-4.5073 2.0267-4.5073 4.5114 0 .3575.0303.7012.1045 1.0285-3.7496-.1829-7.0675-1.98-9.2963-4.7176C1.1426 1.4973.9144 2.27.9144 3.102c0 1.562.8044 2.9466 2.0033 3.7483C2.1931 6.8365 1.4823 6.626.88 6.2946v.0495c0 2.1918 1.5634 4.0123 3.6135 4.4317-.3671.1004-.7673.1485-1.1825.1485-.2887 0-.5802-.0165-.8539-.077.5844 1.7861 2.2426 3.0992 4.2144 3.1418-1.5345 1.2004-3.4829 1.9237-5.5921 1.9237-.3699 0-.7246-.0165-1.0794-.0619 1.9979 1.2884 4.3656 2.024 6.919 2.024 8.2995 0 12.837-6.875 12.837-12.8343 0-.1993-.0069-.3918-.0165-.583.8951-.6352 1.6472-1.4286 2.2605-2.3416z",
  fill: "#036FE2",
  fillRule: "nonzero"
});

var SvgTwitterIcon = function SvgTwitterIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitterIcon.a3660d0f.svg";
export { ForwardRef as ReactComponent };